import { format, isSameDay, subDays } from 'date-fns'

export const getDateGroupLabel = (date: Date) => {
  const today = new Date()

  if (isSameDay(date, today)) return 'Today'
  if (isSameDay(date, subDays(today, 1))) return 'Yesterday'

  return format(date, 'MMMM d, yyyy')
}

export const groupAlertsByDate = (
  alerts: IAlertHistory[],
  page: number,
  pageSize: number,
  labelFormatter: (date: Date) => string = getDateGroupLabel
): AlertDateGroup[] => {
  const sortedAlerts = alerts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
  const paginatedAlerts = sortedAlerts.slice((page - 1) * pageSize, page * pageSize)
  const groups: AlertDateGroup[] = []

  // Group insertion order follows the already date-sorted alerts list.
  paginatedAlerts.forEach((alert, index) => {
    const date = new Date(alert.date)
    const key = format(date, 'yyyy-MM-dd')
    const label = labelFormatter(date)
    const existingGroup = groups.find((group) => group.key === key)

    if (existingGroup) {
      existingGroup.alerts.push({
        alert,
        originalIndex: (page - 1) * pageSize + index,
      })
      return
    }

    groups.push({
      key,
      label,
      alerts: [
        {
          alert,
          originalIndex: (page - 1) * pageSize + index,
        },
      ],
    })
  })

  return groups
}
